import { Theme } from "@emotion/react";
import { CSSObject } from "@emotion/serialize";

export const getInputFieldStyles = (theme: Theme) => {
  const base: CSSObject = {};

  return { base };
};
